import { Helmet, HelmetProvider } from "react-helmet-async"
import { useUIHelper } from "../../../biz/hooks/ui/useUIHelper"
import { useMyOrganization, useOrganization } from "../../../biz/hooks/entities/useOrganization";

export const HelmetHeader = () => {

    const ui = useUIHelper();
    const org = useMyOrganization();

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{!!org?.name ? ui.appName + " - " + org?.name : ui.appName}</title>
                <link rel="canonical" href="https://pro.ohgarden.se" />

                <link rel="preload" href="./fonts/Recoleta-SemiBold.woff2" as="font" type="font/woff2" />
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Abhaya+Libre:wght@400;500;600;700;800&family=Quicksand:wght@300..700&family=Kalam:wght@300;400;700&display=swap');
                </style>
            </Helmet>
        </HelmetProvider>
    )
}
